import React, { useState } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import WorkOutlineIcon from "@mui/icons-material/WorkOutline"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import SelectComponent from "../../../../components/select/select-component"
import CodeViewer from "../../../../components/CodeViewer/code-viewer"

const SelectInputPage = () => {
    const [role, setRole] = useState("viewer")
    const [status, setStatus] = useState("active")

    const roleOptions = [
        { value: "admin", label: "Administrador" },
        { value: "editor", label: "Editor" },
        { value: "viewer", label: "Visualizador" },
    ]

    const statusOptions = [
        { value: "active", label: "Ativo" },
        { value: "review", label: "Em revisão" },
        { value: "blocked", label: "Bloqueado" },
    ]

    const codeBasicUsage = `import SelectComponent from "src/v2/components/select/select-component"

const options = [
  { value: "admin", label: "Administrador" },
  { value: "editor", label: "Editor" },
  { value: "viewer", label: "Visualizador" },
]

const [role, setRole] = useState("viewer")

<SelectComponent
  label="Perfil do usuário"
  value={role}
  options={options}
  onChange={(event) => setRole(event.target.value)}
/>`

    const codePropsType = `type SelectOption = string | { value: string | number; label: string }

type SelectComponentProps = {
  label: string
  value?: string | number
  options: SelectOption[]
  onChange: (event: SelectChangeEvent<any>, child?: React.ReactNode) => void
  startIcon?: React.ReactElement            // ex.: <WorkOutlineIcon />
  width?: number | string                   // largura do container
  error?: boolean
  helperText?: string
  // ...props adicionais são repassados ao Select do MUI
}`

    return (
        <Box sx={{ width: "100%" }}>
            <Stack spacing={3}>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h4" gutterBottom color="common.white">
                            {`SelectComponent`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            {`Componente de seleção de valor único construído sobre o Select do MUI, já estilizado conforme o design system e com suporte a ícone inicial, helper text e estado de erro.`}
                        </Typography>

                        <Box mt={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplo principal`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Select controlado com ícone inicial e helper text, ideal para formulários gerais.`}
                            </Typography>

                            <Box mt={2} sx={{ maxWidth: 420, display: "grid", gap: 2 }}>
                                <SelectComponent
                                    label="Perfil do usuário"
                                    value={role}
                                    startIcon={<WorkOutlineIcon />}
                                    options={roleOptions}
                                    onChange={(event) => setRole(event.target.value)}
                                    helperText="Define permissões da conta."
                                />

                                <SelectComponent
                                    label="Status"
                                    value={status}
                                    startIcon={<CheckCircleOutlineIcon />}
                                    options={statusOptions}
                                    onChange={(event) => setStatus(event.target.value)}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Estados comuns`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Exemplos de uso padrão, com mensagem de erro e desabilitado.`}
                        </Typography>

                        <Box sx={{ display: "grid", gap: 2, maxWidth: 500 }}>
                            <SelectComponent
                                label="Padrão"
                                value=""
                                options={roleOptions}
                                onChange={() => {}}
                                displayEmpty
                            />

                            <SelectComponent
                                label="Com erro"
                                value=""
                                options={roleOptions}
                                onChange={() => {}}
                                error
                                helperText="Selecione uma opção."
                                displayEmpty
                            />

                            <SelectComponent
                                label="Desabilitado"
                                value="editor"
                                options={roleOptions}
                                onChange={() => {}}
                                disabled
                            />
                        </Box>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Uso básico`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Exemplo mínimo de configuração com lista de opções e controle de estado.`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <CodeViewer code={codeBasicUsage} language="jsx" />
                            </Box>
                        </Paper>
                    </Box>
                </Paper>

                <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            {`Propriedades do componente`}
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            {`Principais props expostas pelo SelectComponent. Props extras são repassadas ao Select do MUI.`}
                        </Typography>

                        <Paper variant="outlined">
                            <Box p={2}>
                                <Typography variant="subtitle2" gutterBottom color="common.white">
                                    {`Tipo das props (exemplo em TypeScript`}
                                    {`)`}
                                </Typography>
                                <CodeViewer code={codePropsType} language="tsx" />
                            </Box>
                        </Paper>
                    </Box>
                </Paper>

            </Stack>
        </Box>
    )
}

export default SelectInputPage
